// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1WVQf","row":"Node_row__qzX4f","label":"Node_label__1G3E6","footer":"Node_footer__2GPAi"};